import React, {useCallback} from 'react'
import {Logout} from '../../../../Common/Components/Logout'
import {membersMsalInstance} from '../../../Auth/members-msa'
import {useMBMemberError} from '../../Hooks/UseMBMemberError'
import {useLocation} from 'react-router-dom'
import {useMsal} from '@azure/msal-react'

type MembersAuthLogoutPageProps = {
  to?: string
}
export const MembersAuthLogoutPage: React.VFC<MembersAuthLogoutPageProps> = ({to}) => {
  const throwMBError = useMBMemberError()
  const {search} = useLocation()
  const {inProgress} = useMsal()
  const toUrl = to ?? (new URLSearchParams(search).get('to') ?? '/account')
  const replaceLocation = toUrl
    ? useCallback((): void => location.replace(toUrl), [toUrl])
    : undefined

  const logoutUrl = process.env.REACT_APP_MEMBER_LOGOUT_URL ?? '/logout'
  if (logoutUrl !== '/logout') {
    const redirTo =  toUrl.startsWith('/') ? window.location.origin + toUrl : toUrl
    window.location.href = logoutUrl.replace("{}", encodeURIComponent(redirTo))
    return null
  }

  return <>
    <Logout
      msalInstance={membersMsalInstance}
      navigate={replaceLocation}
      throwMBError={throwMBError}
      postLogoutRedirectUri={toUrl}
      inProgress={inProgress}
    />
  </>
}
